import React, { Component } from 'react';
import { connect } from "react-redux";
import { actions } from './redux';
import { shouldUpdate } from '../../../../utils';
import * as Highcharts from 'highcharts';

export default function ChartWithSyncedZoom(ChartComponent) {
    class _chartSyncWithZoom extends Component {
        constructor(props) {
            super(props);
            this.chartComponentRef = React.createRef();
        }
        componentDidMount() {
            this._setup();
        }
        componentDidUpdate() {
            this._setup();
        }
        componentWillReceiveProps(nextProps) {
            if (nextProps.chartZoom != null)
                this._onChartZoomChanged(nextProps.chartZoom);
        }
        shouldComponentUpdate(nextProps, nextState) {
            return shouldUpdate(this, nextProps, nextState, ["onLoadComplete", "chartZoom"]);
        }
        render() {
            return <ChartComponent {...this.props} ref={this.chartComponentRef} />
        }

        _resetZoom = false;

        _setup() {
            const chart = this._getChart();
            Highcharts.removeEvent(chart.xAxis[0], 'afterSetExtremes');
            Highcharts.removeEvent(chart, 'selection');
            Highcharts.addEvent(chart.xAxis[0], 'afterSetExtremes', (event) => this._onAfterSetExtremes(event));
            Highcharts.addEvent(chart, 'selection', (event) => this._onChartSelection(event));

            this.props.syncZoom({
                min: null,
                max: null,
                reset: true
            });
        }
        _onChartZoomChanged({ min, max, reset }) {
            const chart = this._getChart();
            chart.xAxis[0].setExtremes(min, max);
            if (reset && chart.resetZoomButton)
                chart.resetZoomButton = chart.resetZoomButton.destroy();
            else if (!reset && !chart.resetZoomButton)
                chart.showResetZoom();
        }
        _onChartSelection(event) {
            if (event.resetSelection)
                this._resetZoom = true;
        }
        _onAfterSetExtremes(event) {
            if (event.trigger === 'zoom') {
                this.props.syncZoom({
                    min: event.min,
                    max: event.max,
                    reset: this._resetZoom
                });
                if (this._resetZoom) {
                    const chart = this._getChart();
                    if (chart.resetZoomButton)
                        chart.resetZoomButton = chart.resetZoomButton.destroy();
                    this._resetZoom = false;
                }
            }
        }
        _getChart() {
            return this.chartComponentRef.current.chart.current.getChart();
        }
    }

    const bindAction = dispatch => ({
        syncZoom: (chartZoom) => dispatch(actions.syncZoom(chartZoom))
    });
    const mapStateToProps = (state, ownProps) => ({
        chartZoom: state.chartwithsyncedzoom.chartZoom
    });

    return connect(mapStateToProps, bindAction)(_chartSyncWithZoom);
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ChartWithSyncedZoom/ChartWithSyncedZoom.js